/* CampaignPicker — secondary tagging selector for finance transactions.
 * Mirrors FundPicker but for the Campaign dimension (Kickoff Fundraiser 2026,
 * Growing Together, etc.). Module-scoped cache so dozens of forms don't
 * re-fetch the list.
 */
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

let cache = null;
let pending = null;

export const invalidateCampaignsCache = () => { cache = null; };

const fetchCampaigns = async () => {
  if (cache) return cache;
  if (pending) return pending;
  pending = axios.get(`${BACKEND_URL}/api/admin/campaigns`, { withCredentials: true })
    .then((r) => { cache = r.data?.campaigns || []; return cache; })
    .catch(() => { cache = []; return cache; })
    .finally(() => { pending = null; });
  return pending;
};

const KIND_LABEL = {
  event: 'Events',
  program: 'Programs',
  initiative: 'Initiatives',
  operations: 'Operations',
  general: 'General',
};

const CampaignPicker = ({ value, onChange, allowNone = true, disabled = false,
                          ariaLabel = 'Campaign / Program' }) => {
  const [campaigns, setCampaigns] = useState([]);
  useEffect(() => { fetchCampaigns().then(setCampaigns); }, []);

  // Group by kind for a cleaner picker
  const byKind = (kind) => campaigns.filter((c) => (c.kind || '').toLowerCase() === kind);

  return (
    <select value={value || ''} onChange={(e) => onChange(e.target.value || null)}
      disabled={disabled}
      className="w-full px-2.5 py-1.5 border border-[#E5E7EB] rounded text-xs bg-white"
      aria-label={ariaLabel} data-testid="campaign-picker">
      {allowNone && <option value="">— No campaign tag —</option>}
      {Object.keys(KIND_LABEL).map((kind) => {
        const items = byKind(kind);
        if (!items.length) return null;
        return (
          <optgroup key={kind} label={KIND_LABEL[kind]}>
            {items.map((c) => (
              <option key={c.id} value={c.id}>{c.code} — {c.name}</option>
            ))}
          </optgroup>
        );
      })}
    </select>
  );
};

export default CampaignPicker;
